import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemTypeSharedIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.38 8.48C12.15 8.34 11.86 8.34 11.63 8.48L5.60999 11.98C5.37999 12.11 5.23999 12.36 5.23999 12.63V19.63C5.23999 19.9 5.37999 20.14 5.60999 20.28L11.63 23.78C11.86 23.92 12.15 23.92 12.38 23.78L18.4 20.28C18.63 20.15 18.77 19.9 18.77 19.63V12.63C18.77 12.36 18.63 12.12 18.4 11.98L12.38 8.48ZM11.38 21.89L6.72999 19.19V13.83L11.38 16.48V21.89ZM12 15.41L7.29999 12.73L12 10L16.7 12.73L12 15.41ZM17.27 19.19L12.63 21.89V16.48L17.27 13.83V19.19Z"
        fill={color}
      />
      <path
        d="M19.53 3.47C17.42 1.39 14.75 0.25 12 0.25C9.24998 0.25 6.57998 1.39 4.46998 3.47C4.17998 3.76 4.16998 4.24 4.46998 4.53C4.75998 4.82 5.23998 4.83 5.52998 4.53C7.34998 2.73 9.64998 1.75 12 1.75C14.35 1.75 16.65 2.74 18.47 4.53C18.76 4.82 19.24 4.82 19.53 4.53C19.82 4.24 19.82 3.76 19.53 3.47Z"
        fill={color}
      />
      <path
        d="M8.50003 7.30999C9.43003 6.46999 10.67 5.99999 12 5.99999C13.33 5.99999 14.57 6.45999 15.5 7.29999C15.8 7.57999 16.28 7.55999 16.56 7.24999C16.84 6.93999 16.82 6.46999 16.51 6.18999C15.31 5.09999 13.71 4.48999 12.01 4.48999C10.31 4.48999 8.71003 5.08999 7.51003 6.17999C7.20003 6.45999 7.18003 6.92999 7.46003 7.23999C7.74003 7.54999 8.21003 7.56999 8.52003 7.28999L8.50003 7.30999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemTypeSharedIcon.displayName = 'ItemTypeSharedIcon';
